ready(qs('.btn-lisez'), () => {

    ael(window, 'scroll', () => {
        const screenrH = window.innerHeight;
        if (window.scrollY >= (screenrH/2)) {
            qs('.btn-lisez').classList.add('show--');
        }
        else {
            qs('.btn-lisez').classList.remove('show--');
        }
    });
});


// WEBPACK FOOTER //
// ./src/scripts/components/BtnLisez.js